import React, { useEffect } from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import PropTypes from 'prop-types';
import { useForm } from '@uhg-abyss/web/hooks/useForm';

export const ByTin = ({ id, inputModel, inputLabel, ...props }) => {
  const MAX_LENGTH = 11;
  const MIN_LENGTH = 9;

  const isTinValid = (value) => {
    return (value.match(/\d/g) || []).length === 9;
  };

  const form = useForm();
  useEffect(() => {
    form.setValue(inputModel, '');
  }, []);

  return (
    <React.Fragment>
      <TextInput
        {...props}
        id={inputLabel}
        aria-label="type here to enter a TIN "
        label="TIN"
        maxLength={MAX_LENGTH}
        validators={{
          required: 'Billing TIN is required.',
          validate: {
            isValidTIN: (value) => {
              return (
                (value.length >= MIN_LENGTH &&
                  !value.includes('--') &&
                  !value.startsWith('-') &&
                  !value.endsWith('-') &&
                  isTinValid(value)) ||
                'Billing TIN is invalid.'
              );
            },
          },
        }}
        formatter={(value) => {
          return value.replace(
            /[!@#$%^&*)({}<>,.[\]+_`~=\\|';":/?A-Za-z]/g,
            ''
          );
        }}
        isClearable
        autoComplete="off"
        model={inputModel}
      />
    </React.Fragment>
  );
};

ByTin.propTypes = {
  inputModel: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
};

ByTin.defaultProps = {};
